module.exports = __webpack_public_path__ + "img/cafedelmor.ab01479e.jpg";